import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { CONTENT_ROUTES } from "../routes/content-routes";
import { useMatch } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { WEB_ROUTES } from "../routes/web-routes";
import { OpenCloseContactContext } from "../contexts/contact";
import Header from "../components/header";
import Footer from "../components/footer";
import { AppLoader } from "../components/app-loader";
import { Helmet } from "react-helmet";
import { useUtilities } from "../hooks/utilities";
import {
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  XIcon,
  WhatsappIcon,
  LinkedinIcon,
} from 'react-share';

export default function NewsSingle() {
  const [article, setArticle] = useState({});
  let { setOpenCloseContact } = useContext(OpenCloseContactContext);
  const singleArticle = useMatch(WEB_ROUTES.NEWS + "/:news");
  const [loading, setLoading] = useState({});
  const [page, setPage] = useState({});
  let { getMetaSnippet } = useUtilities();
  const shareUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}/news/${article.slug}`
      : "";

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  useEffect(() => {
    setLoading(true);

    //Get service
    axios
      .get(
        CONTENT_ROUTES.POST_PAGE(
          "/posts",
          singleArticle?.params?.news + "&_embed&order_by=menu_order&order=asc"
        )
      )
      .then((res) => {
        let newsResponse = res.data?.length ? res.data[0] : {};
        setArticle(newsResponse);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  }, [singleArticle]);

  return (
    <>
      <Helmet>
        <title>{article?.meta?.nant_seo_title || article?.title?.rendered + ` - Nant Power`}</title>
        <meta
          name="description"
          content={article?.meta?.nant_seo_description || getMetaSnippet(article?.content?.rendered)}
        />
      </Helmet>
      <Header />
      <main>
        {Object.keys(article).length ? (
          <>
            <section className="bg-white pt-16 md:pb-16 pb-8">
              <div className="container mx-auto md:flex items-center md:px-0 px-8">
                <div className="md:w-5/12 w-full">
                  <div className="flex">
                    <img
                      className="mr-5 h-12 -mt-2"
                      src="/images/electric-bolt-solid.svg"
                      alt="Nant Power Project Icon"
                    />
                    <div className="text-xl font-bold text-gray-500">
                      <span
                        dangerouslySetInnerHTML={{
                          __html:
                            new Date(article.date).getDate() +
                            " " +
                            monthNames[new Date(article.date).getMonth()] +
                            " " +
                            new Date(article.date).getFullYear(),
                        }}
                      />
                    </div>
                  </div>

                  <div className="clear-both"></div>
                  <div className="text-base leading-7 text-[#0070b9] w-full md:px-14 px-0 mt-10">
                    <h1 className="md:pb-5 md:mr-5 mr-0 md:text-4xl text-3xl font-semibold">
                      {article?.title?.rendered}
                    </h1>
                  </div>
                </div>

                <div className="relative md:w-9/12 w-full mt-10 md:mt-0">
                  <img
                    className=" w-full object-cover"
                    src={article?._embedded["wp:featuredmedia"][0]?.source_url}
                    alt={article?.title?.rendered}
                  />

                  <div
                    className="z-30 absolute bottom-0 left-0 bg-black/30 py-2 px-4 text-white text-sm"
                    dangerouslySetInnerHTML={{
                      __html:
                        article?._embedded["wp:featuredmedia"][0]?.caption
                          ?.rendered,
                    }}
                  />
                </div>
              </div>
            </section>

            <div className="bg-white pb-16">
              <div className="container mx-auto md:px-0 px-8">
                <div className="md:max-w-5xl w-full">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: article?.content?.rendered?.replace(
                        /<p.*?>/g,
                        "<p class='mb-5'>"
                      ),
                    }}
                  />
                </div>
               <div className="pt-8 text-gray-500">Share this article</div>
               <div className="flex gap-2 mt-auto pt-4">
                <LinkedinShareButton url={shareUrl} quote={article.title}>
                  <LinkedinIcon size={40} round />
                </LinkedinShareButton>
                <TwitterShareButton url={shareUrl} title={article.title}>
                  <XIcon size={40} round />
                </TwitterShareButton>
                <WhatsappShareButton url={shareUrl} title={article.title}>
                  <WhatsappIcon size={40} round />
                </WhatsappShareButton>
              </div>
                <div className="clear-both"></div>
              </div>

            </div>
            
          </>
        ) : (
          <AppLoader />
        )}
      </main>
      <Footer />
    </>
  );
}
